import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Container,
    Card,
    CardImg,
    CardBody,
    CardText,
    Badge,
} from "reactstrap";
import MetaTags from "react-meta-tags"
import "./style.scss"
import { useSelector } from "react-redux"
import location from "assets/images/location.png"

import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png"

const UserMode = () => {
    const [activeCanvas, setActiveCanvas] = useState(null)
    const [flag, setFlag] = useState(1);
    const [unitImage, setUnitImages] = useState(null)

    const [canvas, setCanvas] = useState('');
    const [toolTipData, setToolTipData] = useState('');
    const modeData = useSelector(state => state.Mode)
    const [images, setImages] = useState([]);

    useEffect(() => {
        setFlag(c => c + 1)
        if (activeCanvas ?.constrains ?.type ?.type !== "appartment" || activeCanvas ?.constrains ?.type ?.type !== "unit" ) {
            setImages(activeCanvas ?.images)
        }
    }, [activeCanvas])


    const initCanvas = () => {
        const canvas = new fabric.Canvas(`canvas`)
        canvas.setDimensions({ width: 1188, height: 670 })

        // background image shoulf reset with every change in the canvas  
        // (chexk it in admin page)
        // new fabric.Image.fromURL(activeCanvas ?.path, function (img) {
        //     canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
        //         scaleX: canvas.width / img.width,
        //         scaleY: canvas.height / img.height
        //     });
        // })


        return canvas
    }
    useEffect(() => {
        setCanvas(initCanvas());
    }, []);



    useEffect(() => {
        setActiveCanvas(modeData ?.images[0])
    }, [modeData])


    const renderSavedCanvasData = async (activeCanvas) => {
        if (canvas !== "") {
            await canvas ?.clear()
            await canvas ?.renderAll();
            //  myStateRef.current = activeCanvas

            new fabric.Image.fromURL(activeCanvas ?.path, function (img) {
                canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {

                    originX: 'left',
                    scaleX: canvas.getWidth() / img.width,   //new update
                    scaleY: canvas.getHeight() / img.height,   //new update
                    originY: 'top',

                });
            })
            fabric.Canvas.prototype.setCursor
                = function (value) {
                    value = 'pointer'; // Add your own logic here to override
                    this.upperCanvasEl.style.cursor = value;
                };
            activeCanvas ?.shapes ?.forEach((shape, index) => {
                let shapeData = {
                    ...shape,
                    left: shape.left * 2.22,
                    top: shape.top * 2.2333,
                    width: shape.width * 2.22,
                    height: shape.height * 2.22,
                }
                if (shape.type === "Circle") {
                    shapeData = {
                        ...shape,
                        left: shape.left * 2.22,
                        top: shape.top * 2.2333,
                        radius: shape.radius * 2.22,
                    }
                    var circle = new fabric.Circle({ ...shapeData });
                    circle.set('selectable', false)

                    canvas.add(circle);
                } else if (shape.type === "Rect") {
                    var rect = new fabric.Rect({ ...shapeData });
                    rect.set('selectable', false)

                    canvas.add(rect);
                } else if (shape.type === "Pin") {
                    shapeData = {
                        ...shape,
                        left: shape.left * 2.3,
                        top: shape.top * 2.6,
                    }
                    fabric.Image.fromURL(location, function (img) {
                        img.scale(0.1).set({
                            ...shapeData
                        })
                        canvas.add(img)
                    })
                } else {
                    shapeData = {
                        ...shape,
                        left: shape.left * 2.3,
                        top: shape.top * 2.5,
                    }
                    var node = new fabric.Circle({
                        radius: 20 * 1.2,
                        fill: 'rgba(0,0,0,0)',
                        left: 0,
                        stroke: "black",
                        top: 30,
                        strokeWidth: 4,
                    });
                    var nodeChild = new fabric.Circle({
                        radius: 10 * 1.2,
                        fill: 'rgba(0,0,0,0)',
                        left: 12,
                        fill: "black",
                        top: 42,
                    });
                    var group = new fabric.Group([node, nodeChild], { ...shapeData })
                    group.set('selectable', false)

                    canvas.add(group);
                }
            })

            canvas.renderAll();
        }
    }
    useEffect(() => {
        if (canvas !== "") {
            canvas.on('mouse:over', function (e) {

                const value = e.target
                if (value) {
                    const tt = document.getElementById("toolTip")
                    setToolTipData(value.id)
                    tt.style.visibility = 'visible'
                    if (e.target.type === "Pin") {

                        tt.style.top = `${e ?.target ?.top + 50  }px`
                        tt.style.left = `${e ?.target ?.left + 15}px`
                    } else {

                        tt.style.top = `${e ?.target ?.top + e ?.target ?.height }px`
                        tt.style.left = `${e ?.target ?.left + e ?.target ?.width }px`
                    }

                }
            })
            canvas.on('mouse:out', function (e) {
                const value = e.target

                if (value) {
                    // setToolTipData("")
                    const tt = document.getElementById("toolTip")
                    if (e.target) {
                        tt.style.visibility = 'hidden'
                    }
                }

            })
            canvas.on('mouse:down', (e) => {
                const value = e.target
                if (value) {
                    const tt = document.getElementById("toolTip")
                    tt.style.visibility = 'hidden'
                    const navigateTo = value.idImage.id
                    const canvasTarget = modeData.images.find(item => {
                        return item.id === parseInt(navigateTo)
                    })
                    setActiveCanvas({ ...canvasTarget })

                }
            });
        }

    }, [canvas])

    useEffect(() => {
        renderSavedCanvasData(activeCanvas)
    }, [activeCanvas])


    // const myDiv = document.getElementById('toolTip');

    // myDiv ?.addEventListener("mouseover", function (event) {
    //     // highlight the mouseover target
    //     myDiv.style.visibility = 'visible'

    // }, false);

    // useEffect(() => {
    //      setTimeout(() => {
    //         const canvasTarget = modeData.images.find(item => {
    //             return item.id ===  1815
    //         })
    //          setActiveCanvas(canvasTarget)
    //      }, 5000);
    // }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Interactive  Mode</title>
                </MetaTags>
                <Container fluid className="bg-light">
                    <Row>
                        <Col className="active position-relative " md={12}>
                            <div id="toolTip"  >
                                {/* {toolTipData} */}
                                <div className="websitPages"  >
                                    <div>
                                        <Card className="comCard">
                                            <CardImg src={compoundImg}  ></CardImg>
                                            <CardBody style={{ minHeight: "165px" }}>
                                                <CardText tag="h4" className="font-size-16  " style={{ color: "#3a3335", fontWeight: 800 }}>Ammarr</CardText>
                                                <CardText tag="h4" className="mb-1"><span className="text-muted font-size-14 pe-2">Starting From </span>
                                                    <span className="font-size-16">10,000,000  EGP</span>
                                                </CardText>
                                                <CardText tag="h6" className="font-size-12 text-muted pt-2">Up to  {toolTipData} years installments  </CardText>

                                                <Badge className="bgBadge font-size-12">Duplex</Badge>

                                            </CardBody>
                                        </Card>
                                    </div>
                                </div>
                            </div>

                            <canvas id={`canvas`}  ></canvas>
                            {activeCanvas ?.constrains ?.type ?.type === "unit"
                                // &&
                                // activeCanvas ?.images ?.find(img => img.id === activeCanvas.id)
                                    ?
                                    <button
                                        type="button"
                                        onClick={() => {
                                            const image = activeCanvas ?.images ?.find(img => img.id === activeCanvas ?.id)
                                            if (image ?.id) {
                                                const currentIndex = images.findIndex(img => img.id === activeCanvas.id)
                                                const nextImg = activeCanvas ?.images.find((img, index) => currentIndex - 1 === index)
                                                        setActiveCanvas({ ...activeCanvas, ...nextImg })
                                            } else {
                                                const canvasTarget = modeData.images.find(item => {
                                                    return item.id === activeCanvas ?.comesForm ?.id
                                                    })
                                                 setActiveCanvas({ ...canvasTarget})
                                            }
                                        }}
                                        style={{ position: "absolute", top: "42%", left: "-7px", width: "40px", height: "40px", background: "none", border: "none", outline: "none", }}>
                                        <i className="fas fa-arrow-left fa-2x slider-icon "  ></i>
                                    </button> : null}
                            {activeCanvas ?.constrains ?.type ?.type === "unit" 
                           
                             ? <button
                                onClick={() => {
                                    if (images.find(img => img.id === activeCanvas ?.id)) {
                                        const currentIndex = images.findIndex(img => img.id === activeCanvas.id)
                                        const nextImg = images.find((img, index) => currentIndex + 1 === index)
                                        setActiveCanvas({ ...activeCanvas, ...nextImg })
                                    } else {
                                        setUnitImages({
                                            id: activeCanvas.id,
                                            path: activeCanvas.path
                                        })
                                        setActiveCanvas({ ...activeCanvas, ...activeCanvas ?.images[0]})
                                    }
                                }}
                                style={{ position: "absolute", top: "42%", right: "85px", width: "40px", height: "40px", background: "none", border: "none", outline: "none", }}>
                                <i className="fas fa-arrow-right fa-2x slider-icon" ></i>
                            </button> : null}
                        </Col>

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}
export default UserMode


